<template>
  <div>
    <div class="clear"></div>
    <!-- Content

    


    =============================================-->
    <section id="content" style="max-width: 1280px; margin-left: auto; margin-right: auto;">
      <div class="content-wrap" style="margin-left: auto; margin-right: auto;"> 
        <!--  PRODUCT TABLE SECTION -->
        <div class="container clearfix" style="max-width: 1200px;">
          <div class="row" style="width: 100%;margin-top: 50px;">
            <div style="text-align: center;width: 75%;margin-left: auto; margin-right: auto; ">
              <h3
                class="customer_title the-title-font"
                style="color:  rgb(255, 135, 135); margin-left:auto; margin-right: auto; text-align: center ; margin-bottom: 10px; "
              >ตรวจสอบรายการสินค้า</h3>
            </div>
          </div>
          <div class="row" style="border-bottom: 1px rgba(241, 241, 241, 1) solid;">
            <div class="autoheight col-lg-8 col-md-8 col-12" style="min-height:550px;">
              <div class="table-responsive" style="margin-top:50px;">
                <table class="table cart">
                  <thead>
                    <tr>
                      <th style="width:5%;" class="cart-product-remove">&nbsp;</th>
                      <th style="width:15%;" class="cart-product-thumbnail">&nbsp;</th>
                      <th class="cart-product-name">ชื่อสินค้า</th>

                      <th style="width:15%;" class="cart-product-quantity">จำนวน (ชิ้น)</th>
                      <th style="width:15%;" class="cart-product-price">ราคา</th>
                      <th style="width:15%;" class="cart-product-deposit">ค่าประกัน</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="cart_item"
                      v-for="(item, ind) in items"
                      :key="ind"
                      style="font-size:13px; font-weight: 300;"
                    >
                      <td class="cart-product-remove"></td>

                      <td>
                        <img
                          style="width:95% !important  height:fit-content !important"
                          :src="getProductPath(item.mainImage)"
                          alt="Pink Printed Dress"
                        />
                      </td>

                      <td
                        class="cart-product-name"
                      >{{item.name}}  {{getColorName(item.color)}} ขนาด {{item.size}}</td>
                      <td class="cart-product-quantity">{{item.reservedQuantity}} x</td>

                      <td class="cart-product-price">
                        <span class="amount">{{formatPrice(item.rentalPrice * item.reservedQuantity)}}</span>
                      </td>

                      <td class="cart-product-deposit">
                        <span class="amount">{{formatPrice(item.bail * item.reservedQuantity)}}</span>
                      </td>
                    </tr>

                    <tr class="cart_item">
                      <td colspan="10">
                        <div class="row clearfix"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- col-8 -->
            <div
              class="col-lg-4 col-lg-4 col-12 colclearfix"
              style="    background-color: #efefef; margin-bottom: 50px; margin-top: 70px; max-height: 400px;"
            >
              <h3 style="    margin-bottom: 3px;padding-top: 1em;">สรุปยอดรวมทั้งหมด</h3>

              <div
                class="table-responsive"
                style="background-color:white; padding: 30px 5px; maring-top: 50px;"
              >
                <table class="table cart">
                  <tbody>
                    <tr class="cart_item" style="font-size: 16px;">
                      <td class="cart-product-name">ราคาสินค้า</td>

                      <td class="cart-product-name" style="font-size: 16px;">
                        <span class="amount">{{this.formatPrice(this.totalRental)}} บาท</span>
                      </td>
                    </tr>
                    <tr class="cart_item" style="font-size: 16px;">
                      <td class="cart-product-name">ค่าประกันสินค้า</td>

                      <td class="cart-product-name">
                        <span class="amount">{{this.formatPrice(this.totalBail)}} บาท</span>
                      </td>
                    </tr>
                    <tr class="cart_item" style="font-size: 20px; border-top: 1px solid #7e7e7e;">
                      <td class="cart-product-name">ยอดรวมทั้งหมด</td>

                      <td class="cart-product-name">
                        <span
                          class="amount color lead"
                          style=" 
                          font-weight: 700;
                          font-size: 20px;
                          "
                        >
                          <strong>{{this.formatPrice(this.grandtotal)}}บาท</strong>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="row" style="margin-top:20px;">
                <!-- <div
                    class="btn btn-danger"
                    style="width:90%; margin: 10px auto; cursor : pointer;"
                    @click="checkq()"
                >ชำระค่าเช่าสินค้า</div>-->
              </div>
            </div>
            <!-- col -->
          </div>
        </div>

        <!--  CUSTOMER SECTION -->
        <div class="row customer_section" style="max-width:1150px;margin-left: auto; margin-right: auto;  ">
           <div class="col-lg-12 col-md-12 col-12">
          <div class="row" style="width: 100%;margin-top: 50px;">
            <div style="text-align: center;width: 75%;margin-left: auto; margin-right: auto; ">
              <h3
                class="customer_title the-title-font"
                style="  margin-bottom: 40px; color:  rgb(255, 135, 135); margin-left:auto; margin-right: auto; text-align: center ; "
              >ตรวจสอบข้อมูลในการจัดส่งสินค้า</h3>
            </div>
          </div>
          <div class="clear;"></div>
          <div class="row" style="width: 100%;">
            <div class="col-lg-12 col-md-12 col-12">
              <div
              id="customer_info_block"
                style=" text-align: center;width: 75%;margin-left: auto; margin-right: auto;  background-color: #efefef; padding: 30px 10px; "
              >
                <div class="row">
                  <div class="customer_label col-lg-5 col-md-5 col-6">ชื่อลูกค้า :</div>
                  <div class="col-lg-6 col-md-6 col-6 customer_info">{{customer.name}}</div>
                </div>
                <div class="row" style="margin-top: 20px;">
                  <div class="customer_label col-lg-5 col-md-5 col-6">เบอร์ติดต่อ :</div>
                  <div class="col-lg-6 col-md-6 col-6 customer_info">{{customer.phone}}</div>
                </div>
                <div class="row" style="margin-top: 20px;">
                  <div class="customer_label col-lg-5 col-md-5 col-6">ที่อยู่จัดส่ง :</div>
                  <div class="col-lg-6 col-md-6 col-6 customer_info">{{customer.address}}</div>
                </div>
                <div class="row" style="margin-top: 20px;">
                  <div class="customer_label col-lg-5 col-md-5 col-6">วันรับและวันคืนชุด :</div>
                  <div
                    class="col-lg-6 col-md-6 col-6 customer_info"
                  >{{formatDate(theCheckIn)}} ~ {{formatDate(theCheckOut)}}</div>
                </div>
                <div class="row" style="margin-top: 20px;">
                  <div class="customer_label col-lg-5 col-md-5 col-6">ช่องทางการส่งของ :</div>
                  <div class="col-lg-6 col-md-6 col-6 customer_info">{{delivery}}</div>
                </div>
                <div class="row">
                  <div class="customer_label col-lg-5 col-md-5 col-6">Remark :</div>
                  <div class="col-lg-6 col-md-6 col-6 customer_info">{{remark1}}</div>
                </div>
              </div>
               </div>
          </div>
        </div>
        <div class="clear;"></div>
        <div class="row" style="width: 100%;">
          <div
            style=" text-align: center;width: 100%;margin-left: auto; margin-right: auto;  padding: 30px 10px; "
          >
            <button
              
              @click="submitOrder()"
              type="button"
              style="width:40%; margin-left :auto; margin-top:auto;"
              class="btn btn-primary opt-btn"
            >ยืนยันข้อมูลการเช่าชุด</button>
            <div style="display: inline-block;padding-left: 10px; padding-right: 10px;"></div>
            <button
            
              @click="moveToCart()"
              type="button"
              style="width:25%; margin-left :auto; margin-top:auto;"
              class="btn btn-dark opt-btn"
            >กลับไปแก้ไขข้อมูล</button>
          </div>
           </div >
        </div>
        <!-- ข้อมูลผู้รับสินค้า -->
        <!-- container container3 clearfix -->
      </div>
      <!-- content-wrap -->
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
import store from "@/store.js";
import axios from "axios";

// import HotelDatePicker from "vue-hotel-datepicker";

export default {
  mixins: [myMixins],
  data() {
    return {
      ordHead: {},

      remark1: "",
      customer: {
        name: "",
        phone: "",
        address: ""
      },
      delivery: "",
      deliveryOption: ["มารับเอง", "ผ่านเมสเซนเจอร์", "ผ่าน EMS / Kerry"],
      ava: "",
      optitem: 10,
      optitemSelected: 0,
      checkq_validated: 0,
      checkq_result: 0,
      checkq_message: "",
      theCheckIn: new Date(),
      theCheckOut: new Date(),
      startingDateValue: new Date(),
      endingDateValue: new Date(),
      colorSelected: "",
      colorShow: false,
      sizeSelected: "",
      sizeShow: false,
      rentalDateShow: false,
      optitemShow: false,
      branchSelected: "",
      branchShow: false,
      items: [],
      baseUrl: "",
      groupid: "",
      colorlist: [],
      branchlist: [],
      itemSizes: [],
      itemColors: [],
      theImage: "",
      main: {},
      reviews: [],
      imagelist: []
    };
  },
  async created() {
    this.groupid = this.$route.params.groupid;
    this.items = await JSON.parse(localStorage.getItem("rentalitem"));

    this.ordHead = await JSON.parse(localStorage.getItem("ordHead"));

    store.state.cart = await this.items;

    if (this.items === null || this.items === undefined) {
      store.state.listnumber = 0;
      this.items = [];
      this.startingDateValue = new Date();
      this.theCheckIn = new Date();
      this.endingDateValue = this.addDay(new Date(), 1);
      this.theCheckOut = this.addDay(new Date(), 1);
    } else {
      store.state.listnumber = await this.items.length;
      //   this.startingDateValue = await new Date(store.state.cart[0]["startDate"]);
      //   this.theCheckIn = await new Date(store.state.cart[0]["startDate"]);
      //   this.endingDateValue = await new Date(store.state.cart[0]["endDate"]);
      //   this.theCheckOut = await new Date(store.state.cart[0]["endDate"]);
      // }
    }

    if (this.ordHead !== null && this.ordHead !== undefined) {
      this.customer.name = this.ordHead.customerName;
      this.customer.phone = this.ordHead.customerPhone;
      this.customer.address = this.ordHead.customerAddress;
      this.remark1 = this.ordHead.remark1;
      this.delivery = this.ordHead.receivingMethod;
      this.startingDateValue = new Date(this.ordHead.pickupDate);
      this.theCheckIn = new Date(this.ordHead.pickupDate);

      this.endingDateValue = new Date(this.ordHead.returnDate);
      this.theCheckOut = new Date(this.ordHead.returnDate);
    }

    // var shopid = '553735b8-2713-4e79-a294-8184d1b12987';
    //*** ใช้ token1 แทน */

     var response = await axios.post(
        store.state.apiUrl +  "/web-api/web/all-list", {}, store.state.apiHeader 
      );

    var alllist = response.data;

    this.colorlist = alllist.colors;

  },

  async mounted() {
    await this.getPosts();
    // await this.getColors();

    if (this.ordHead !== null && this.ordHead !== undefined) {
      this.customer.name = this.ordHead.customerName;
      this.customer.phone = this.ordHead.customerPhone;
      this.customer.address = this.ordHead.customerAddress;
      this.remark1 = this.ordHead.remark1;
      this.delivery = this.ordHead.receivingMethod;
      this.startingDateValue = new Date(this.ordHead.pickupDate);
      this.theCheckIn = new Date(this.ordHead.pickupDate);

      this.endingDateValue = new Date(this.ordHead.returnDate);
      this.theCheckOut = new Date(this.ordHead.returnDate);
    }

   

    

    // await this.getReviews();
    await this.getBranch();
    await this.getAllImage();
    this.scrollToTop();
  },
  computed: {
    totalRental: function() {
      var total = 0;
      for (var i = 0; i < this.items.length; i++) {
        total = total + (this.items[i].rentalPrice * this.items[i].reservedQuantity ) ;
      }
      return total;
    },
    totalBail: function() {
      var total = 0;
      for (var i = 0; i < this.items.length; i++) {
       total = total +  (this.items[i].bail * this.items[i].reservedQuantity );
      }
      return total;
    },
    grandtotal: function() {
      return this.totalRental + this.totalBail;
    }
  },
  watch: {
    optitemSelected() {
      this.checkq_validated = 0;
    },

    colorSelected() {
      this.resetAll();
    },
    sizeSelected() {
      this.resetAll();
    },
    branchSelected() {
      this.resetAll();
    }
  },
  methods: {
    removeProduct(id) {
      var ind = this.items.findIndex(x => x.productItemId === id);
      this.items.splice(ind, 1);
      store.state.cart = this.items;
      localStorage.setItem("rentalitem", JSON.stringify(this.items));
    },
    async submitOrder() {
      // Use sweetalert2
      this.$swal({
        title: "<b>ยืนยันการเช่าชุด</b>",
        text: "ข้อมูลที่ยืนยันจะส่งไปยังแอดมิน เพื่อเตรียมชุดให้ท่าน",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยันข้อมูล",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.value) {
          var res = null;
          try {
            if (
              this.items === null ||
              this.items === undefined ||
              this.items.length <= 0
            ) {
              this.$swal(
                "ส่งข้อมูลไม่สำเร็จ",
                "คุณยังไม่ได้เลือกสินค้า",
                "error"
              );

              return;
            }
            if (
              this.ordHead === null ||
              this.ordHead === undefined ||
              this.ordHead === {}
            ) {
              this.$swal(
                "ส่งข้อมูลไม่สำเร็จ",
                "คุณยังไม่ได้ใส่ข้อมูล เพื่อจัดส่งสินค้า",
                "error"
              );
              return;
            }

            res = await axios.post(
              store.state.apiUrl + "/web-api/web/request-order",
              {
                header: this.ordHead,
                dlist: this.items
              },
              store.state.apiHeader
            );
          } catch (err) {
            res = null;
          }

          if (res !== null) {
            if (res.data.includes("WEB")) {
              store.state.ordernumber = res.data;
              localStorage.clear();
              this.$router.push("/complete");
            } else {
              this.$swal(
                "ส่งข้อมูลไม่สำเร็จ",
                "มีข้อผิดพลาดเกิดขึ้นระหว่างการส่งข้อมูล กรุณารอสักรู่และส่งข้อมูลอีกครั้ง",
                "error"
              );
            }
          }
        }
      });

      // if (this.ordHead === null || this.ordHead === undefined) {
      // }

      localStorage.setItem("ordHead", JSON.stringify(this.ordHead));

    },
    async addToCart() {
      var url =
        store.state.apiUrl + "/web-api/web/productitem/" + this.ava;
      var prd = await this.getOne(url);

      var detail = {
        orderHeaderId: "",
        mainImage: prd.mainImage, // *** เพิ่มเติม
        name: prd.name, // *** เพิ่มเติม
        branchId: this.branchSelected.branchId,
        productItemId: this.ava,
        code: prd.code,
        reservedQuantity: this.optitemSelected,
        rentalPrice: prd.rentalPrice,
        bail: prd.bail,
        state: true,
        startDate: this.formatDate(this.theCheckIn),
        endDate: this.formatDate(this.theCheckOut),
        createBy: "webuser",
        updateBy: "webuser"
      };

      store.state.cart.push(detail);
      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));
      var it = JSON.parse(localStorage.getItem("rentalitem"));

      store.state.listnumber = it.length;
    },
    resetAll() {
      this.checkq_validated = 0;
      this.checkq_result = 0;
      this.checkq_message = "";
    },
    async checkq() {
      this.checkq_validated = 0;
      this.colorShow = false;
      this.sizeShow = false;
      this.branchShow = false;
      this.optitemShow = false;
      this.rentalDateShow = false;

      if (
        this.colorSelected === "" ||
        this.colorSelected === null ||
        this.colorSelected === undefined
      ) {
        this.colorShow = true;
      }

      if (
        this.sizeSelected === "" ||
        this.sizeSelected === null ||
        this.sizeSelected === undefined
      ) {
        this.sizeShow = true;
      }

      if (
        this.branchSelected === "" ||
        this.branchSelected === null ||
        this.branchSelected === undefined
      ) {
        this.branchShow = true;
      }

      if (
        this.theCheckIn === "" ||
        this.theCheckIn === null ||
        this.theCheckIn === undefined ||
        this.theCheckOut === "" ||
        this.theCheckOut === null ||
        this.theCheckOut === undefined
      ) {
        this.rentalDateShow = true;
      }

      if (
        this.optitemSelected === "" ||
        this.optitemSelected === null ||
        this.optitemSelected === undefined ||
        this.optitemSelected === 0
      ) {
        this.optitemShow = true;
      }

      if (
        !this.colorSelected ||
        !this.sizeSelected ||
        !this.branchSelected ||
        !this.optitemSelected ||
        this.rentalDateShow
      ) {
        return;
      }

      var fil = this.items.filter(
        x =>
          x.size === this.sizeSelected.toString() &&
          x.color === this.colorSelected.toString()
      );

      // There is an ITEM in combination SIZE and COLOR
      // มีสินค้าหลัง filter ด้วย สีและขนาด
      if (fil.length >= 1) {
        var ci = [
          {
            productItemId: fil[0].productItemId,
            pickupDate: this.formatDate(this.theCheckIn),
            returnDate: this.formatDate(this.theCheckOut),
            branchId: this.branchSelected.branchId,
            qty: this.optitemSelected
          }
        ];

        var res = null;
        try {
          res = await axios.post(
            // "https://wintershop-online.com/api/orderdetail/checkq",
            store.state.apiUrl + "/api/orderdetail/checkq",

            ci
          );
        } catch (err) {
          res = null;
        }

        if (res !== null) {
          if (res.data.length > 0) {
            if (res.data[0].result === 1) {
              this.checkq_validated = 1;
              this.checkq_result = 1;
              this.ava = res.data[0].productItemId;
              //  สินค้ามีให้เช่าได้
            } else {
              this.checkq_validated = 0;
              this.checkq_result = 2;
              this.ava = "";
              //  สินค้ามีไม่พอ
            }
            this.checkq_message = res.data[0].desc;
          } else {
            this.ava = "";
          }
        }
      } else {
        this.checkq_result = 2;
        this.checkq_message = "สินค้าหมดขั่วคราว";
        this.ava = "";
      }

      //
    },
    newCheckIn: function(newDate) {
      this.theCheckIn = newDate;

      for (var i = 0; i < store.state.cart.length; i++) {
        store.state.cart[i].startDate = this.formatDate(newDate);
      }

      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));
    },
    newCheckOut: function(newDate) {
      this.theCheckOut = newDate;

      for (var i = 0; i < store.state.cart.length; i++) {
        store.state.cart[i].endDate = this.formatDate(newDate);
      }

      localStorage.setItem("rentalitem", JSON.stringify(store.state.cart));
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async getAllImage() {
      for (var i = 0; i < this.items.length; i++) {
        var co = this.imagelist.filter(x => x.color === this.items[i].color);
        if (
          co.length === 0 &&
          (this.items[i].mainImage !== null ||
            this.items[i].mainImage !== undefined ||
            this.items[i].mainImage !== "")
        ) {
          var obj = {
            image: this.items[i].mainImage,
            color: this.items[i].color
          };

          this.imagelist.push(obj);
        }
      }
    },

    getColorName(code) {
      var res = this.colorlist.find(c => c.code === code);
      if (res === undefined || res === null) {
        return "ไม่ระบุ";
      } else {
        return res.description;
      }
    },

    formatPrice(value) {
      value = this.convertToNum(value);
      var amount = isNaN(value) ? 0 : value;

      return amount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    convertToNum(value) {
      if (typeof value === "string") {
        value = Number(value.replace(",", ""));
      }
      if (isNaN(value)) {
        value = 0;
      }
      return value;
    },
    changeImage(list) {
      this.theImage = list.image;
      this.selectColor(list.color);
    },
    selectSize(size) {
      this.sizeSelected = size;
    },
    selectDelivery(de) {
      this.delivery = de;
    },
    selectColor(color) {
      var have = this.imagelist.find(x => x.color === color);

      this.colorSelected = color;

      this.theImage = have.image;
    },
    selectBranch(brn) {
      this.branchSelected = brn;
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },

    getColors() {
      // axios.get("https://wintershop-online.com/api/color").then(response => {
      //   this.colorlist = response.data;
      // });
    },
    getBranch() {
      // axios.get("https://wintershop-online.com/api/branch").then(response => {
      //   this.branchlist = response.data;
      // });
    },
    // async getReviews() {
    //   var response = await axios.get(
    //     "https://wintershop-online.com/api/reviewimage/" + this.groupid
    //   );

    //   this.reviews = await response.data;
    // },
    async getPosts() {
      //   let url = buildUrl();

      this.itemSizes = this.items.map(x => x.size);

      // Make it unique array
      this.itemSizes = this.itemSizes.filter(this.onlyUnique);

      this.itemColors = this.items.map(x => x.color);

      // Make it unique array
      this.itemColors = this.itemColors.filter(this.onlyUnique);

      // var mainres = await axios.get(
      //   "https://wintershop-online.com/api/productitem/" + this.groupid
      // );
      // this.main = await mainres.data;
    },
    // imagePath(mainImage) {
    //   if (mainImage === undefined || mainImage === null || mainImage === "") {
    //     return "https://wintershop-online.com/webimage/defaultimage.png";
    //   } else {
    //     return "https://wintershop-online.com/webimage/item/" + mainImage;
    //   }
    // },
    getReviewPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return "https://wintershop-online.com/webimage/defaultimage.png";
      } else {
        return "https://wintershop-online.com/webimage/review/" + mainImage;
      }
    }
  },
  components: {}
};
</script>
 
<style >
.customer_label {
  font-size: 18px;
  padding-top: 15px;
  text-align: right;
}

.customer_info {
  font-size: 18px;
  padding-top: 15px;
  text-align: left;
}
.customer_section {
  width: 100% !important;
}
.datepicker {
  top: -380px !important;
  position: absolute !important;
}
.datepicker__inner {
  padding-bottom: 0;
}
/* .datepicker {
  position: absolute !important;
  top: 380px !important;
} */
.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.notChoose {
  color: #444;
  background-color: white;
}

.choose {
  color: white !important;
  background-color: #444 !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 3px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 10px;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #d8d8d8a8;
  border-radius: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}

.button.button-border {
  border: 1px solid #c7c7c7;
  background-color: transparent;
  color: #333;
  line-height: 36px;
  font-weight: 700;
  font-size: 12px;
  text-shadow: none;
}
.product-desc {
  font-family: "Mitr", sans-serif !important;
}
.nc_size {
  border: 1px solid #c7c7c7;
  background-color: white;
}
.c_size {
  border: 1px solid #c7c7c7;
  background-color: #333;
}

.button-medium {
  font-family: "Mitr", "supermarket" !important;
  font-size: 14px !important;
  font-weight: 300 !important;
}

/************* VUE HOTEL DATEPICKUP **************/
@media screen and (min-width: 768px) {
  .datepicker__months {
    /* FONT-WEIGHT: 100; */
    width: 500px !important;
  }
}
.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.con-vs-popup .vs-popup .datepicker {
  left: -285px;
  padding: 0 10px;
  z-index: 999 !important;
}

.datepicker__input {
  font-size: 12px !important;
  line-height: 4 !important;
  padding: 4px 25px 2px !important;
}

.con-vs-popup .vs-popup {
  width: 750px;
}

.datepicker.datepicker--closed {
  display: none;
}
/* .con-vs-popup .vs-popup .datepicker__inner {
  padding: 0;
  float: left;
  padding-bottom: 5px;
} */

.con-vs-popup .vs-popup .datepicker__month-day {
  visibility: visible;
  text-align: center;
  margin: 0;
  border: 0;
  height: 25px;
  padding-top: 5px !important;
  vertical-align: middle;
}

.con-vs-popup .vs-popup .datepicker__week-row {
  border-bottom: 5px solid #fff;
  height: 20px;
}
.con-vs-popup .vs-popup .datepicker {
  left: -285px !important;
  padding: 0 10px;
  z-index: 999 !important;
}

.zoomimage {
  width: 400px;
}
.datepicker__tooltip {
  display: none !important;
}

.demo-alignment {
  vertical-align: middle;
}

.datepicker__tooltip {
  display: none;
}
@media only screen and (max-width: 900px) {
  .product-desc {
    margin-top: 20px !important;
  }
  #imageselect {
    padding-left: 20px !important;
    padding-right: 0 !important;
  }
}
@media only screen and (max-width: 578px) {
  .opt-btn{
    width: 40% !important;
    font-size: 12px !important;
  }
    .customer_info{
    font-size: 12px !important;
    padding-left: 0 !important;
  }
  .customer_label{
    font-size: 14px !important;
  }
  #customer_info_block{
    width: 100% !important;
  }
  .autoheight {
    min-height: auto !important;
  }
  .customer_title {
    font-size: 28px !important;
  }
  .customer_section {
    /* max-width: 350px !important; */
    padding: 5px 5px !important;
  }
  .customer_label {
    text-align: left !important;
  }

  #review-product {
    padding-left: 20px !important;
  }
  .alert-info {
    font-size: 12px !important;
  }
  .product {
    max-width: 578px !important;
    height: fit-content !important;
  }
  .product-desc {
    max-width: 520px !important;
    margin-top: 20px !important;
    padding-left: 40px !important;
  }
  #imageselect {
    padding-left: 20px !important;
    padding-right: 0 !important;
  }
  #mainimage_wrapper {
    text-align: left !important;
    padding-left: 20px !important;
  }
  #mainimage {
    max-width: 95% !important;
  }
  .oc-item {
    margin-right: 60px !important;
  }

  .container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .product_review {
    padding-left: 20 !important;
    padding-right: 20 !important;
  }
  .item_reviewed {
    max-width: 300px !important;
  }
  .image_fade {
    width: 100% !important;
  }
  .dis_btn {
    position: relative;
    cursor: pointer;
    outline: none;
    white-space: nowrap;
    margin: 5px;
    padding: 0 22px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    background-color: #909392;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
    font-family: Mitr !important;
    font-size: 14px !important;
    font-weight: 300 !important;
    line-height: 42px;
    transition: all 0.2s ease-in-out;
    border-radius: 3px;
    padding: 0 26px;
    border: 2px solid #444 !important;
    color: #333;
    line-height: 36px;
    font-weight: 700;
    text-shadow: none;
  }
}
</style>